export default "__VITE_ASSET__BWVaqpJc__"